export interface RenaultLocalCampaignTelemarketingOrderDataDTO {
  IdOrderData: string;
  IdOrder: string;
  Name: string;
  Surname: string;
  Email: string;
  Phone: string;
  Address: string;
  Location: string;
  Cp: string;
  Province: string;
  CarModel: string;
  LicensePlate: string;
  ChasisNumber: string;
  CarYears: string;
  IdStatus: number;
  Status: string;
  TimedOutContactList: boolean;
}


export class RenaultLocalCampaignTelemarketingOrderDataOtherMediasDTO {
  IdOrderData: string;
  Campaign: string;
  CampaignMedia: string;
  Status: string;
  SendDate: string;
  Contact: string;
  CompleteName: string;
  Html: string;
}

export class RenaultCampaignContactImpactHistoric {
  Campaign: string;
  Type: string;
  Media: string;
  SendDate: string;
  Origin: string;
  IdOrderData: string;
  IdCampaign: number;
  Month: number;
  Year: number;
  Language: number;
}

export class RenaultCampaignContactImpactHistoricParams {
  Phone: string;
  Email: string;
  TypeSent: number;
  IdSent: string;
}